var ratingSnippetGlobalSettings, ratingSnippetObserverTimeout = !1, ratingSnippetObserver = !1, ratingSnippetSkuMap = [], ratingSnippetSkuMapChar = !1, ratingSnippetMaxReq = 6e3, ratingSnippetBatchNum = 0, useRatingSnippetV2 = ["hometownapparel.com", "knotty-knickers", "knotty-knickers-uk"];
function getRatingSnippetEndpoint(e) {
  return useRatingSnippetV2.includes(e) ? "https://api.reviews.io/v2/product/rating-batch" : "https://api.reviews.io/product/rating-batch"
}
/**
 * 检查 a 是否包含 b 中的任何一个元素
 * @param {string} a 
 * @param {Set<any>} b 
 * @returns {boolean}
 */
function _containsAny(a, b) {
  for (const item of b) {
    if (a.includes(item)) {
      return true;
    }
  }
  return false;
}
// function getRatingSnippetValues(e, ratings, sku) {
//   var rating_count = 0
//     , rating_value = 0;
//   const skuSet = new Set(sku.map(s => s.toString().trim().toLowerCase()));
//   if (useRatingSnippetV2.includes(e.store)) {
//     for (var o = 0; o < ratings.length; o++)
//       for (var s = 0; s < ratings[o].skus.length; s++)
//         if (-1 != sku.indexOf(ratings[o].skus[s])) {
//           rating_count += ratings[o].num_ratings,
//             rating_value += ratings[o].average_rating * ratings[o].num_ratings;
//           break
//         }
//   } else {
//     let cacheSku = [];
//     for (var i in ratings)
//       null != ratings[i] && null != ratings[i].sku
//         && (
//           skuSet.has(ratings[i].sku.toString().trim().toLowerCase())
//           ||
//           ratings[i].lookup
//           && _containsAny(ratings[i].lookup.toString().trim().toLowerCase(), skuSet)
//         )
//         && -1 == cacheSku.indexOf(ratings[i].sku)
//         && (rating_value += parseFloat(ratings[i].average_rating) * ratings[i].num_ratings,
//           rating_count += parseFloat(ratings[i].num_ratings),
//           cacheSku.push(ratings[i].sku))
//   }
//   var u = null != e.text && "" != e.text ? " " + e.text : ""
//     , d = null != e.starsText ? " " + e.starsText : "";
//   return 1 == rating_count && (u = e.singularText && "" != e.singularText ? " " + e.singularText : " Reviews" == u ? " Review" : u,
//     d = e.singularStarsText ? " " + e.singularStarsText : " Star"),
//     rating_count > 1 && !d && (d = " Stars"),
//   {
//     rating_count: rating_count,
//     rating: rating_value / rating_count,
//     starsText: d,
//     ratingText: u,
//     snippetTitle: ""
//   }
// }

function getRatingSnippetValues(e, t, n) {
  let ratingCount = 0;
  let ratingSum = 0;
  // 预处理SKU为Set以便快速查找
  const skuSet = new Set(n.map(sku => sku && sku.toString().trim().toLowerCase()));
  if (useRatingSnippetV2.includes(e.store)) {
    // 版本V2的逻辑优化
    for (const item of t) {
      if (!item?.skus) continue;
      for (const sku of item.skus) {
        if (skuSet.has(sku)) {
          ratingCount += item.num_ratings;
          ratingSum += item.average_rating * item.num_ratings;
          break; // 找到匹配后立即跳出循环
        }
      }
    }
  } else {
    // 版本V1的逻辑优化
    const processedSkus = new Set();
    for (const item of t) {
      if (!item?.sku) continue;
      const itemSku = item.sku.toString().trim().toLowerCase();
      if (processedSkus.has(itemSku)) continue; // 已处理过的SKU跳过
      // 检查直接SKU匹配
      let matchFound = skuSet.has(itemSku);
      // 检查lookup中的SKU匹配
      if (!matchFound && item.lookup) {
        const lookupSkus = item.lookup.toString().trim().toLowerCase().split(';');
        matchFound = lookupSkus.some(sku => skuSet.has(sku));
      }
      if (matchFound) {
        ratingSum += parseFloat(item.average_rating) * item.num_ratings;
        ratingCount += parseFloat(item.num_ratings);
        processedSkus.add(itemSku); // 标记为已处理
      }
    }
  }
  // 处理文本显示逻辑
  const ratingText = e.text?.trim() ? ` ${e.text}` : "";
  let starsText = e.starsText?.trim() ? ` ${e.starsText}` : "";
  if (ratingCount === 1) {
    starsText = e.singularStarsText?.trim() ? ` ${e.singularStarsText}` : " Star";
  } else if (ratingCount > 1 && !starsText) {
    starsText = " Stars";
  }
  return {
    rating_count: ratingCount,
    rating: ratingCount > 0 ? ratingSum / ratingCount : 0,
    starsText,
    ratingText,
    snippetTitle: ""
  };
}
function renderSnippet(e, t, n, a) {
  if (t < a.minReviewCount)
    return "";
  var r = ""
    , i = a.decimalPlaces;
  if (null == i && (i = 2),
    "minimal" === a.mode)
    r += '<i aria-hidden="true" class="ruk-icon-percentage-star--100"></i>',
      r += '<span class="ruk-rating-snippet-count">' + (e = Math.round(100 * e) / 100).toFixed(i) + "</span>",
      1 == a.linebreak ? r += "<br />" : r += '<span style="display: inline-block; min-width: 8px"></span>',
      n && (r += '<span class="ruk-rating-snippet-count">' + t + n + "</span>");
  else {
    roundedRating = Math.round(4 * e) / 4;
    for (var o = 1; o <= 5; o++)
      roundedRating >= o ? r += '<i aria-hidden="true" class="ruk-icon-percentage-star--100"></i>' : roundedRating >= o - .25 ? r += '<i aria-hidden="true" class="ruk-icon-percentage-star--75"></i>' : roundedRating >= o - .5 ? r += '<i aria-hidden="true" class="ruk-icon-percentage-star--50"></i>' : roundedRating >= o - .75 ? r += '<i aria-hidden="true" class="ruk-icon-percentage-star--25"></i>' : r += '<i aria-hidden="true" class="ruk-icon-percentage-star--0"></i>';
    1 == a.linebreak && (r += "<br />"),
      1 == a.removeBrackets ? r += '<span class="ruk-rating-snippet-count">' + t + n + "</span>" : r += '<span class="ruk-rating-snippet-count">(' + t + n + ")</span>",
      "extended" == a.mode && (r += '<span style="margin-left: 5px" class="ruk-rating-snippet-count"><b>' + (Math.round(100 * e) / 100).toFixed(i) + "</b> / " + 5..toFixed(i) + "</span>")
  }
  return r
}
reinitialiseRatingSnippet = function () {
  ratingSnippetGlobalSettings && ratingSnippet(ratingSnippetGlobalSettings.class, ratingSnippetGlobalSettings.options)
}
  ,
  ratingSnippet = function (e, t) {
    ratingSnippetGlobalSettings = {
      class: e,
      options: t
    };
    let n = "rating-snippet-stars__css"
      , a = document.getElementById(n)
      , r = ["https://assets.reviews.io/iconfont/legacy/revsglobal-pr-mod/style.css?_t=20240411"]
      , i = !1
      , o = document.querySelectorAll("link");
    for (let e = 0; e < o.length; e++) {
      const t = o[e];
      t.href && r.forEach((e => {
        e == t.href && (i = !0)
      }
      ))
    }
    if (a || i || (a = document.createElement("link"),
      a.rel = "stylesheet",
      a.type = "text/css",
      a.id = n,
      a.href = "https://assets.reviews.io/iconfont/legacy/revsglobal-pr-mod/style.css?_t=20240411",
      document.getElementsByTagName("HEAD")[0].appendChild(a)),
      null == t && (t = {}),
      t.usePolaris) {
      let e = "rating-snippet-polaris__script"
        , t = document.getElementById(e)
        , n = ["https://widget.reviews.io/polaris/build.js", "https://widget.reviews.co.uk/polaris/build.js", "http://localhost:8080/dist/2/build.js"]
        , a = !1
        , r = document.querySelectorAll("script");
      for (let e = 0; e < r.length; e++) {
        const t = r[e];
        t.src && n.forEach((e => {
          e == t.src && (a = !0)
        }
        ))
      }
      t || a || (polarisScript = document.createElement("script"),
        polarisScript.type = "text/javascript",
        polarisScript.id = e,
        polarisScript.async = !0,
        polarisScript.src = "https://widget.reviews.io/polaris/build.js",
        document.getElementsByTagName("head")[0].appendChild(polarisScript))
    }
    null == t.linebreak && (t.linebreak = !1),
      null == t.removeBrackets && (t.removeBrackets = !1),
      null == t.mode && (t.mode = !1),
      null == t.color && (t.color = "#67c116"),
      null == t.textClr && (t.textClr = "#333"),
      null == t.useCustomLookup && (t.useCustomLookup = !1),
      null == t.useProductGroup && (t.useProductGroup = !1),
      null == t.mpnLookup && (t.mpnLookup = !1),
      null == t.customLookupSkuFallback && (t.customLookupSkuFallback = !1),
      null == t.showNumberDatesFormat && (t.showNumberDatesFormat = "dd.MM.yyyy"),
      null == t.minRating && (t.minRating = 1),
      null == t.showNumberDates && (t.showNumberDates = !1),
      null == t.enableSyndication && (t.enableSyndication = !1),
      null == t.enableReviewerAddress && (t.enableReviewerAddress = !0),
      null == t.enableDate && (t.enableDate = !0),
      null == t.translateAverage && (t.translateAverage = "Average"),
      null == t.translateReviews && (t.translateReviews = "Reviews"),
      null == t.translateNoReviews && (t.translateNoReviews = "Be the first to review this product."),
      null == t.translateMoreRatings && (t.translateMoreRatings = "More Ratings"),
      null == t.translateNoComments && (t.translateNoComments = "This review has no comments"),
      null == t.translateReplyFrom && (t.translateReplyFrom = "Reply From"),
      null == t.translatePosted && (t.translatePosted = "Posted"),
      null == t.translateWriteReview && (t.translateWriteReview = "Write a Review"),
      null == t.translateShow && (t.translateShow = "Show"),
      null == t.translateDetails && (t.translateDetails = "More"),
      null == t.translateRateThisProduct && (t.translateRateThisProduct = "Rate This Product"),
      null == t.translateSelectProduct && (t.translateSelectProduct = "Select Product:"),
      null == t.translateWriteReviewPlaceholder && (t.translateWriteReviewPlaceholder = "Write your review here"),
      null == t.translateSubmitReview && (t.translateSubmitReview = "Submit Review"),
      null == t.translateYourNamePlaceholder && (t.translateYourNamePlaceholder = "Your Name"),
      null == t.translateEmailAddressPlaceholder && (t.translateEmailAddressPlaceholder = "Email Address"),
      null == t.translateThankyouForYourReview && (t.translateThankyouForYourReview = "<strong>Thank you</strong> for your review!"),
      null == t.translateYourReviewHasBeenSubmitted && (t.translateYourReviewHasBeenSubmitted = "Your review has been submitted."),
      null == t.translateReviewsCount && (t.translateReviewsCount = "Reviews"),
      null == t.translateVerifiedBuyer && (t.translateVerifiedBuyer = "Verified Buyer"),
      null == t.translateUnverifiedBuyer && (t.translateUnverifiedBuyer = "Unverified Buyer"),
      null == t.translateVerifiedBuyerYes && (t.translateVerifiedBuyerYes = "Yes"),
      null == t.translateVerifiedBuyerNo && (t.translateVerifiedBuyerNo = "No"),
      null == t.translateAnonymousReviewerName && (t.translateAnonymousReviewerName = "Anonymous"),
      null == t.enableProductName && (t.enableProductName = !1),
      null == t.formatReviewCount && (t.formatReviewCount = !1),
      null == t.formatLanguage && (t.formatLanguage = "en-GB"),
      null == t.lang && (t.lang = "en"),
      null == t.snippetPopup && (t.snippetPopup = !0),
      null == t.dataAttributeSelector && (t.dataAttributeSelector = "data-sku"),
      null == t.ignoreCollection && (t.ignoreCollection = !1),
      null == t.anchorToReviewsWidget && (t.anchorToReviewsWidget = !1);
    var s = []
      , l = document.querySelectorAll("." + e);
    if (l.length > 0)
      for (var u = 0; u < l.length; u++) {
        var d = l[u]
          , p = d.getAttribute(t.dataAttributeSelector).split(";");
        d.setAttribute("rating-snippet-batch", ratingSnippetBatchNum),
          (s = s.concat(p)).join(";").length > ratingSnippetMaxReq && (doRatingSnippetReq([...s], t, e, ratingSnippetBatchNum++),
            s = [])
      }
    s.length && doRatingSnippetReq(s, t, e, ratingSnippetBatchNum)
  }
  ;

/**
 * @param {string[]} e sku list
 * @param {*} t store 
 * @param {string} n class name (ruk_rating_snippet)
 * @param {number} a 
 */
const doRatingSnippetReq = function (e, t, n, a) {
  var r;
  ratingSnippetSkuMap = [],
    ratingSnippetSkuMapChar = !1,
    (r = window.XMLHttpRequest ? new XMLHttpRequest : new ActiveXObject("Microsoft.XMLHTTP")).onreadystatechange = function () {
      if (4 == r.readyState && 200 == r.status) {
        var e = JSON.parse(r.responseText)
          , i = document.querySelectorAll("." + n + '[rating-snippet-batch="' + a + '"]');
        if (i.length > 0)
          for (var o = 0; o < i.length; o++) {
            var s = i.item(o)
              , l = s.getAttribute(t.dataAttributeSelector).split(";")
              , u = 0
              , d = ""
              , p = 0
              , c = 0
              , { rating_count: u, rating: p, starsText: g, ratingText: d, snippetTitle: m } = getRatingSnippetValues(t, e, l);
            if (u > 0) {
              c = u,
                t.formatReviewCount && (c = c.toLocaleString(t.formatLanguage));
              let e = Math.round(100 * p) / 100 + g + " - " + c;
              s.setAttribute("title", e),
                s.setAttribute("aria-label", e),
                s.innerHTML = renderSnippet(p, c, d, t),
                s.setAttribute("data-done", !0)
            } else
              t.showEmptyStars && (s.innerHTML = renderSnippet(0, 0, d, t),
                s.setAttribute("data-done", !0));
            !t.usePolaris && !t.anchorToReviewsWidget || s.getAttribute("role") || s.hasAttribute("aria-hidden") || s.setAttribute("role", "button"),
              s.getAttribute("tabindex") || s.setAttribute("tabindex", "0"),
              c < 1 && (t.showEmptyStars ? s.setAttribute("aria-label", m) : (s.removeAttribute("tabindex"),
                s.setAttribute("aria-hidden", !0)),
                s.hasAttribute("aria-hidden") ? s.removeAttribute("role") : s.setAttribute("role", "button")),
              t.anchorToReviewsWidget && (s = document.querySelector(".main-content .ruk_rating_snippet") ? document.querySelector(".main-content .ruk_rating_snippet") : document.querySelector(".main_content .ruk_rating_snippet") ? document.querySelector(".main_content .ruk_rating_snippet") : document.querySelector(".ruk_rating_snippet"),
                document.querySelector("[data-reviewsio-widget='polaris']") ? polaris = document.querySelector("[data-reviewsio-widget='polaris']") : polaris = document.querySelector("#ReviewsWidget"),
                polaris && s && (s.onclick = function () {
                  polaris.scrollIntoView({
                    block: "start",
                    behavior: "smooth"
                  });
                  var e = document.querySelector(".header__group.header__group--left > div");
                  e ? e.focus() : polaris.focus()
                }
                ));
            var b = document.querySelectorAll(".ruk-rating-snippet-count");
            b.length > 0 && b.forEach((function (e) {
              null != t.textClr && (e.style.color = t.textClr)
            }
            )),
              t.callback && t.callback({
                data: e,
                rating: p,
                count: u
              })
          }
      }
    }
    ;
  try {
    e = [...new Set(e)]
  } catch (e) { }
  var i = e.join(";");
  if (i.length,
    "" != (i = encodeURIComponent(i))) {
    var o = "sku=" + i + "&store=" + t.store;
    t.useCustomLookup && (o += "&useCustomLookup=" + t.useCustomLookup),
      t.customLookupSkuFallback && (o += "&customLookupSkuFallback=" + t.customLookupSkuFallback),
      t.useProductGroup && (o += "&useProductGroup=" + t.useProductGroup),
      t.mpnLookup && (o += "&mpnLookup=" + t.mpnLookup),
      ratingSnippetSkuMap.length && (o += "&skumap=" + ratingSnippetSkuMap.join(ratingSnippetSkuMapChar),
        o += "&skumapc=" + ratingSnippetSkuMapChar),
      t.tag && (o += "&tag=" + t.tag),
      t.lang && (o += "&lang=" + t.lang),
      t.enableSyndication && (o += "&enableSyndication=" + t.enableSyndication),
      t.ignoreCollection && (o += "&ignore_collection=" + t.ignoreCollection),
      o.length > 8e3 ? (r.open("POST", getRatingSnippetEndpoint(t.store), !0),
        r.setRequestHeader("Content-type", "application/x-www-form-urlencoded"),
        r.send(o)) : (r.open("GET", getRatingSnippetEndpoint(t.store) + "?" + o, !0),
          r.send());
    var s = document.createElement("div");
    s.innerHTML = '<div id="reviews_fade" style="display:none;z-index:4000"><div id="reviews_container"><div id="reviews_container-close" class="close">&times;</div><div id="reviews_widget" style="position:relative;z-index:4000;-webkit-overflow-scrolling:touch"></div> </div></div>',
      document.body.appendChild(s),
      window.__reviewsIoWidgetList || (window.__reviewsIoWidgetList = []),
      window.__reviewsIoWidgetList.push({
        target: "#reviews_fade #reviews_container",
        widget: "rating-snippet"
      }),
      t.listenForChanges && "MutationObserver" in window && !ratingSnippetObserver && window.addEventListener("load", (e => {
        (ratingSnippetObserver = new MutationObserver((function (e) {
          // 检查节点是否包含 Rating Snippet
          let hasRatingSnippet = false;
          for (const mutation of e) {
            if (hasRatingSnippet) {
              break;
            }
            if (mutation.addedNodes.length > 0) {
              for (const node of mutation.addedNodes) {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  // 检查当前节点或内部节点是否有 .ruk_rating_snippet
                  if (node.matches('.ruk_rating_snippet') || (node.querySelector && node.querySelector('.ruk_rating_snippet'))) {
                    hasRatingSnippet = true;
                    break;
                  }
                }
              }
            }
          }
          if (!hasRatingSnippet) return;
          ratingSnippetObserverTimeout && clearTimeout(ratingSnippetObserverTimeout),
            ratingSnippetGlobalSettings && document.querySelector("." + ratingSnippetGlobalSettings.class + ":not([data-retrieved])") && (ratingSnippetObserverTimeout = setTimeout((function () {
              reinitialiseRatingSnippet()
            }
            ), 1e3))
        }
        ))).observe(document, {
          attributes: !0,
          attributeFilter: ['class', 'data-sku'],
          childList: !0,
          characterData: !1,
          subtree: !0
        })
      }
      ));
    var l = document.querySelectorAll("." + n);
    if (l.length > 0)
      for (var u in l) {
        var d = l.item(u);
        null != t.color && (d.style.color = t.color),
          ("undefined" != typeof productWidget || t.usePolaris) && null == d.onclick && t.snippetPopup && (d.onclick = function (e) {
            var n = this.getAttribute(t.dataAttributeSelector);
            if (this.getAttribute("data-done")) {
              var a = document.getElementsByTagName("html")[0];
              if (document.getElementById("reviews_widget").innerHTML = "",
                t.usePolaris && "undefined" != typeof ReviewsWidget) {
                var r = {
                  store: t.store,
                  widget: "polaris",
                  options: {
                    types: "product_review",
                    lang: t.hasOwnProperty("lang") ? t.lang : "en",
                    layout: "",
                    enable_syndication: t.enableSyndication,
                    per_page: t.polarisPerPage ? t.polarisPerPage : 8,
                    product_review: {
                      sku: n,
                      hide_if_no_results: !1,
                      min_rating: t.minRating ? t.minRating : 1
                    },
                    header: {
                      enable_summary: !0,
                      enable_ratings: !0,
                      enable_attributes: !0,
                      enable_image_gallery: !0,
                      enable_percent_recommended: !1,
                      enable_write_review: null == t.writeButton || t.writeButton,
                      enable_ask_question: !0,
                      enable_sub_header: !0,
                      always_show: !0
                    },
                    filtering: {
                      enable: !0,
                      enable_text_search: !0,
                      enable_sorting: !0,
                      enable_overall_rating_filter: !0,
                      enable_ratings_filters: !0,
                      enable_attributes_filters: !0
                    },
                    reviews: {
                      enable_replies: t.showPopupReplies,
                      enable_avatar: !0,
                      enable_reviewer_name: !0,
                      enable_reviewer_address: t.enableReviewerAddress,
                      reviewer_address_format: "city, country",
                      enable_verified_badge: !0,
                      enable_reviewer_recommends: !0,
                      enable_attributes: !0,
                      enable_product_name: !0,
                      enable_images: !0,
                      enable_ratings: !0,
                      enable_share: !0,
                      enable_helpful_vote: !0,
                      enable_helpful_display: !0,
                      enable_report: !0,
                      enable_date: t.enableDate
                    }
                  },
                  styles: {
                    "--base-font-size": "16px",
                    "--common-button-font-family": "inherit",
                    "--common-button-font-size": "16px",
                    "--common-button-font-weight": "500",
                    "--common-button-letter-spacing": "0",
                    "--common-button-text-transform": "none",
                    "--common-button-vertical-padding": "10px",
                    "--common-button-horizontal-padding": "20px",
                    "--common-button-border-width": "2px",
                    "--common-button-border-radius": "0px",
                    "--primary-button-bg-color": "#0E1311",
                    "--primary-button-border-color": "#0E1311",
                    "--primary-button-text-color": "#ffffff",
                    "--secondary-button-bg-color": "transparent",
                    "--secondary-button-border-color": "#0E1311",
                    "--secondary-button-text-color": "#0E1311",
                    "--common-star-color": t.color,
                    "--common-star-disabled-color": "rgba(0,0,0,0.25)",
                    "--medium-star-size": "22px",
                    "--small-star-size": "19px",
                    "--heading-text-color": "#0E1311",
                    "--heading-text-font-weight": "600",
                    "--heading-text-font-family": "inherit",
                    "--heading-text-line-height": "1.4",
                    "--heading-text-letter-spacing": "0",
                    "--heading-text-transform": "none",
                    "--body-text-color": "#0E1311",
                    "--body-text-font-weight": "400",
                    "--body-text-font-family": "inherit",
                    "--body-text-line-height": "1.4",
                    "--body-text-letter-spacing": "0",
                    "--body-text-transform": "none",
                    "--inputfield-text-font-family": "inherit",
                    "--input-text-font-size": "14px",
                    "--inputfield-text-font-weight": "400",
                    "--inputfield-text-color": "#0E1311",
                    "--inputfield-border-color": "rgba(0,0,0,0.2)",
                    "--inputfield-background-color": "transparent",
                    "--inputfield-border-width": "1px",
                    "--inputfield-border-radius": "0px",
                    "--common-border-color": "rgba(0,0,0,0.15)",
                    "--common-border-width": "1px",
                    "--common-sidebar-width": "190px",
                    "--slider-indicator-bg-color": "rgba(0,0,0,0.1)",
                    "--slider-indicator-button-color": "#0E1311",
                    "--slider-indicator-width": "190px",
                    "--badge-icon-color": "#0E1311",
                    "--badge-icon-font-size": "inherit",
                    "--badge-text-color": "#0E1311",
                    "--badge-text-font-size": "inherit",
                    "--badge-text-letter-spacing": "inherit",
                    "--badge-text-transform": "inherit",
                    "--author-font-size": "inherit",
                    "--author-text-transform": "none",
                    "--avatar-thumbnail-size": "60px",
                    "--avatar-thumbnail-border-radius": "100px",
                    "--avatar-thumbnail-text-color": "#0E1311",
                    "--avatar-thumbnail-bg-color": "rgba(0,0,0,0.1)",
                    "--photo-video-thumbnail-size": "80px",
                    "--photo-video-thumbnail-border-radius": "0px",
                    "--mediaslider-scroll-button-icon-color": "#0E1311",
                    "--mediaslider-scroll-button-bg-color": "rgba(255, 255, 255, 0.85)",
                    "--mediaslider-overlay-text-color": "#ffffff",
                    "--mediaslider-overlay-bg-color": "rgba(0, 0, 0, 0.8))",
                    "--mediaslider-item-size": "110px",
                    "--pagination-tab-text-color": "#0E1311",
                    "--pagination-tab-text-transform": "none",
                    "--pagination-tab-text-letter-spacing": "0",
                    "--pagination-tab-text-font-size": "16px",
                    "--pagination-tab-text-font-weight": "600",
                    "--pagination-tab-active-text-color": "#0E1311",
                    "--pagination-tab-active-text-font-weight": "600",
                    "--pagination-tab-active-border-color": "#0E1311",
                    "--pagination-tab-border-width": "3px"
                  }
                };
                t.useMpn && (r.options.product_review.mpn = n),
                  t.useCustomLookup && (r.options.product_review.lookup = n),
                  t.tag && (r.options.product_review.tag = t.tag),
                  "undefined" != typeof ReviewsWidgetInstances && ReviewsWidgetInstances[Object.keys(ReviewsWidgetInstances)[0]] && "object" == typeof ReviewsWidgetInstances[Object.keys(ReviewsWidgetInstances)[0]].state && "object" == typeof ReviewsWidgetInstances[Object.keys(ReviewsWidgetInstances)[0]].state.config && "string" == typeof ReviewsWidgetInstances[Object.keys(ReviewsWidgetInstances)[0]].state.config.widget && "polaris" == ReviewsWidgetInstances[Object.keys(ReviewsWidgetInstances)[0]].state.config.widget && "object" == typeof ReviewsWidgetInstances[Object.keys(ReviewsWidgetInstances)[0]].state.config.styles && (r.styles = ReviewsWidgetInstances[Object.keys(ReviewsWidgetInstances)[0]].state.config.styles),
                  t.polarisStyles && (t.polarisStyles.styles ? r.styles = t.polarisStyles.styles : r.styles = t.polarisStyles),
                  t.polarisHeader && (t.polarisHeader.header ? r.options.header = t.polarisHeader.header : r.options.header = t.polarisHeader),
                  t.polarisReviews && (t.polarisReviews.reviews ? r.options.reviews = t.polarisReviews.reviews : r.options.reviews = t.polarisReviews),
                  t.polarisFiltering && (t.polarisFiltering.filtering ? r.options.filtering = t.polarisFiltering.filtering : r.options.filtering = t.polarisFiltering),
                  new ReviewsWidget("#reviews_widget", r)
              } else {
                r = {
                  store: t.store,
                  sku: n,
                  css: t.css,
                  primaryClr: t.color,
                  neutralClr: "#EBEBEB",
                  buttonClr: "#EEE",
                  textClr: t.textClr,
                  tabClr: "#eee",
                  questions: !0,
                  showTabs: !1,
                  ratingStars: !1,
                  showAvatars: !0,
                  snippetPopup: !t.snippetPopup || t.snippetPopup,
                  minRating: t.minRating ? t.minRating : 1,
                  hidePoweredBy: !!t.hidePoweredBy && t.hidePoweredBy,
                  hideLogo: !!t.hideLogo && t.hideLogo,
                  showNumberDates: t.showNumberDates,
                  showNumberDatesFormat: t.showNumberDatesFormat,
                  enableProductName: t.enableProductName,
                  enableDate: t.enableDate,
                  enableReviewerAddress: t.enableReviewerAddress,
                  translateAverage: t.translateAverage,
                  translateReviews: t.translateReviews,
                  translateNoReviews: t.translateNoReviews,
                  translateMoreRatings: t.translateMoreRatings,
                  translateNoComments: t.translateNoComments,
                  translateReplyFrom: t.translateReplyFrom,
                  translatePosted: t.translatePosted,
                  translateWriteReview: t.translateWriteReview,
                  translateShow: t.translateShow,
                  translateDetails: t.translateDetails,
                  translateRateThisProduct: t.translateRateThisProduct,
                  translateSelectProduct: t.translateSelectProduct,
                  translateWriteReviewPlaceholder: t.translateWriteReviewPlaceholder,
                  translateSubmitReview: t.translateSubmitReview,
                  translateYourNamePlaceholder: t.translateYourNamePlaceholder,
                  translateEmailAddressPlaceholder: t.translateEmailAddressPlaceholder,
                  translateThankyouForYourReview: t.translateThankyouForYourReview,
                  translateYourReviewHasBeenSubmitted: t.translateYourReviewHasBeenSubmitted,
                  translateReviewsCount: t.translateReviewsCount,
                  translateVerifiedBuyer: t.translateVerifiedBuyer,
                  translateUnverifiedBuyer: t.translateUnverifiedBuyer,
                  translateVerifiedBuyerYes: t.translateVerifiedBuyerYes,
                  translateVerifiedBuyerNo: t.translateVerifiedBuyerNo,
                  translateAnonymousReviewerName: t.translateAnonymousReviewerName,
                  formatReviewCount: !!t.formatReviewCount && t.formatReviewCount,
                  formatLanguage: t.hasOwnProperty("formatLanguage") ? t.formatLanguage : "en-GB",
                  lang: t.hasOwnProperty("lang") ? t.lang : "en"
                };
                t.useMpn && (r.mpn = n),
                  t.useCustomLookup && (r.lookup = n),
                  t.useProductGroup && (r.productGroup = n),
                  t.tag && (r.tag = t.tag),
                  null != t.writeButton && (r.writeButton = t.writeButton),
                  productWidget("reviews_widget", r)
              }
              document.getElementById("reviews_fade").style.display = "block",
                document.body.classList.add("reviews-popup"),
                a.classList.add("reviews-popup")
            }
          }
          )
      }
    document.getElementById("reviews_fade").onclick = function (e) {
      var t = document.getElementsByTagName("html")[0];
      document.getElementById("reviews_fade").style.display = "none",
        document.body.classList.remove("reviews-popup"),
        t.classList.remove("reviews-popup")
    }
      ,
      document.getElementById("reviews_container-close").onclick = function () {
        var e = document.getElementsByTagName("html")[0];
        document.getElementById("reviews_fade").style.display = "none",
          document.body.classList.remove("reviews-popup"),
          e.classList.remove("reviews-popup")
      }
      ,
      document.querySelector("#reviews_fade #reviews_container").onclick = function (e) {
        return e.stopPropagation(),
          !1
      }
  }
};
"function" == typeof ratingSnippetCallback && ratingSnippetCallback();
